export default {
  title: "Апарати",
  subtitle: "Управување со лабораториски апарати и нивната конфигурација",
  add: "Додај апарат",
  edit: "Уреди",
  delete: "Избриши",
  refresh: "Освежи",
  navigate: "Отворање на детали на апаратот",
  add_title: "Додавање апарат",
  add_subtitle: "Регистрирајте нов апарат на оваа локација",
  subtitle_name: "Апарат",
  subtitle_id: "ID на апарат",
  subtitle_lis_id: "LIS ID",
  subtitle_location: "Локација",
  subtitle_name_tooltip: "Назив на апаратот",
  subtitle_id_tooltip: "Системски идентификатор",
  subtitle_lis_id_tooltip: "LIS интеграциски клуч",
  subtitle_location_tooltip: "Локација на апаратот",
  subtitle_serial: "Сер. №",
  subtitle_serial_tooltip: "Сериски број или идентификациска ознака",
  subtitle_decimal_separator: "Дец. знак",
  subtitle_decimal_separator_tooltip: "Децимален знак во нумеричките резултати",
  subtitle_note: "Забелешка",
  subtitle_note_tooltip: "Забелешка за апаратот",
  edit_title: "Уредување апарат",
  delete_title: "Бришење апарат",
  delete_message: "Овој апарат ќе биде трајно отстранет. Сите поврзани канали исто така ќе бидат избришани.",
  delete_dependency_checking: "Се проверува дали апаратот има поврзана конфигурација...",
  delete_dependency_check_failed:
    "Поврзаната конфигурација не можеше да се провери. Обидете се повторно пред да го избришете апаратот.",
  delete_has_channels:
    "Овој апарат не може да се избрише бидејќи сè уште има конфигурирани канали. Прво отстранете ги од страницата Канали.",
  delete_has_tests:
    "Овој апарат не може да се избрише бидејќи сè уште има конфигурирани тестови. Прво отстранете ги од картичката Тестови.",
  delete_has_panels:
    "Овој апарат не може да се избрише бидејќи сè уште има конфигурирани панели. Прво отстранете ги од картичката Панели.",
  delete_has_sample_types:
    "Овој апарат не може да се избрише бидејќи сè уште има конфигурирани типови примероци. Прво отстранете ги од картичката Типови примероци.",
  delete_has_flags:
    "Овој апарат не може да се избрише бидејќи сè уште има конфигурирани флагови. Прво отстранете ги од картичката Флагови.",
  delete_has_rights:
    "Овој апарат не може да се избрише бидејќи сè уште има конфигурирани права за пристап. Прво отстранете ги од картичката Права.",

  fields: {
    name: "Назив",
    name_hint: "Приказно ime за апаратот, прикажано низ целиот систем",
    name_placeholder: "пр. Cobas e801, Sysmex XN-1000",
    location: "Локација",
    location_hint: "Физичка локација каде што е инсталиран апаратот",
    decimal_separator: "Децимален знак",
    decimal_separator_hint:
      "Знак кој се користи како децимална точка/запирка во нумеричките резултати од апаратот. Мора да одговара на излезниот формат на апаратот.",
    decimal_separator_placeholder: ". или ,",
    mapping_key: "LIS ID",
    mapping_key_hint: "Надворешен идентификатор за поврзување со апаратот во LIS/HIS",
    mapping_key_placeholder: "пр. COBAS01",
    serial: "Сериски / Ознака",
    serial_hint: "Сериски број или ознака на апаратот",
    serial_placeholder: "пр. SN-12345",
    note: "Забелешка",
    note_hint: "По желба — видливо во заглавието и насоките",
    note_placeholder: "пр. Главен хематолошки анализатор, маса 2",
  },

  validation: {
    name_required: "Називот е задолжителен",
    name_too_long: "Називот мора да биде 100 знаци или помалку",
    name_taken: "Веќе постои апарат со овој назив",
    location_required: "Локацијата е задолжителна",
    decimal_separator_required: "Децималниот знак е задолжителен",
    mapping_key_too_long: "LIS ID мора да биде 100 знаци или помалку",
    mapping_key_taken: "Веќе постои апарат со овој LIS ID",
    serial_too_long: "Серискиот број мора да биде 100 знаци или помалку",
    note_too_long: "Забелешката мора да биде 500 знаци или помалку",
  },

  snackbar_added: 'Апаратот "{name}" е додаден',
  snackbar_updated: 'Апаратот "{name}" е ажуриран',
  snackbar_deleted: 'Апаратот "{name}" е избришан',
  loadFailed: "Не успеа вчитувањето на апаратите",

  onboarding: {
    configure_channel: "Конфигурирај канал",
  },

  list: {
    search_placeholder: "Пребарување апарати",
    tab_all: "Сите апарати",
    filter_location_all: "Сите локации",
    filter_location_tooltip: "Филтрирај по локација",
    filter_location_active_tooltip: "Филтрирано по: {name}",
    status_total: "{count} апарат | {count} апарати",
    navigate: "Отворање на детали на апаратот",
    collapse_group: "Свиткување на локацијата",
    expand_group: "Проширување на локацијата",
    channels_total: "Вкупно канали",
    channels_connected: "Поврзани канали",
    channels_running: "Активни канали",
    channels_enabled: "Активирани канали",
    mapping_key_tooltip: "Надворешен клуч за поврзување за идентификација на апаратот во поврзани LIS/HIS системи",
    status_healthy: "Каналот е поврзан",
    status_degraded: "Каналот не е поврзан",
    status_offline: "Каналот не е активен",
    status_no_channels: "Нема конфигуриран канал",
    channel_label_total: "Вкупно",
    channel_label_connected: "Поврзани",
    channel_label_running: "Активни",
    channel_label_enabled: "Активирани",
    toolbar: {
      refresh: "Освежи апарати",
    },
    columns: {
      name: "Апарат",
      mapping_key: "LIS ID",
      decimal_separator: "Децимален знак",
      decimal_separator_tooltip:
        "Знакот користен како децимален разделувач во нумеричките резултати на апаратот. Ако е поставен погрешно, сите нумерички вредности ќе се читаат погрешно.",
      decimal_dot: "точка",
      decimal_comma: "зарез",
      channels: "Канали",
      location: "Локација",
      driver: "Драјвер / Протокол",
      driver_hint: "Комуникациски протокол кој го користат каналите на апаратот",
      test_count: "Бр. Тестови",
    },
    no_channels: "Нема канали",
    empty: {
      title: "Нема достапни апарати",
      description: "Сè уште нема конфигурирани апарати.",
    },
  },

  page_header: {
    description: "Забелешка за конкретен апарат.",
  },

  detail: {
    save: "Зачувај промени",
    reset: "Ресетирај",
    toolbar: {
      refresh_tests: "Освежи тестови",
      refresh_panels: "Освежи панели",
      refresh_sample_types: "Освежи видови примероци",
      refresh_rights: "Освежи права",
      refresh_flags: "Освежи знамиња",
      refresh_mappings: "Освежи соодветствија",
      refresh_processors: "Освежи процесори",
    },
  },

  tabs: {
    details: "Детали",
    tests: "Тестови",
    panels: "Панели",
    sample_types: "Видови примероци",
    rights: "Права",
    flags: "Знамиња",
  },

  tests_tabs: {
    tests_list: "Тестови",
    mappings: "LIS соодветствија",
    processors: "Процесори",
  },

  test_detail: {
    description: "Забелешка за конкретен тест.",
    tabs: {
      basic_data: "Основни податоци",
      mapping: "LIS соодветствија",
      processors: "Процесори",
    },
    navigate: "Отворање на детали на тестот",
    save_success: "Тестот е зачуван успешно",
    save_error: "Грешка при зачувување на тестот",
    toggle_activated: "Тестот е активиран успешно",
    toggle_deactivated: "Тестот е деактивиран успешно",
    toggle_error: "Грешка при промена на статусот на тестот",
    mapping_added: "Соодветствието '{key}' е додадено",
    mapping_updated: "Соодветствието '{key}' е ажурирано",
    mapping_deleted: "Соодветствието '{key}' е отстрането",
    mapping_add_error: "Грешка при додавање на соодветствие. Ве молиме обидете повторно.",
    mapping_update_error: "Грешка при ажурирање на соодветствие. Ве молиме обидете повторно.",
    mapping_delete_error: "Грешка при отстранување на соодветствие. Ве молиме обидете повторно.",
    processor_added: "Процесорот #{rank} е додаден",
    processor_updated: "Процесорот #{rank} е ажуриран",
    processor_deleted: "Процесорот #{rank} е отстранет",
    processor_add_error: "Грешка при додавање на процесор. Ве молиме обидете повторно.",
    processor_update_error: "Грешка при ажурирање на процесор. Ве молиме обидете повторно.",
    processor_delete_error: "Грешка при отстранување на процесор. Ве молиме обидете повторно.",
    delete_success: "Тестот е успешно избришан",
    delete_error: "Неуспешно бришење на тестот. Ве молиме обидете повторно.",

    delete: "Бришење на тест",
    master_card: {
      cannot_be_ordered: "Не може да се нарача",
      cannot_be_ordered_hint: "Тестот не може да прима нарачки од LIS",
      cannot_be_result: "Без резултати",
      cannot_be_result_hint: "Тестот не може да произведе вредности на резултати",
      created_on: "Создаден на",
    },
    unsaved_dialog_title: "Незачувани промени",
    unsaved_dialog_subtitle: "Имате незачувани промени.",
    unsaved_dialog_body: "Дали сакате да ги зачувате промените пред да напуштите, или да ги отфрлите?",
    unsaved_save_and_leave: "Зачувување и продолжување",
    unsaved_discard: "Отфрлање",
    unsaved_stay: "Останување",
    subtitle_code_tooltip: "Код на тестот за LIS нарачки",
    subtitle_name_tooltip: "Прикажано назив на тестот",
    subtitle_id_tooltip: "Системски идентификатор",
  },

  panel_detail: {
    tabs: {
      basic_data: "Основни податоци",
      mapping: "LIS соодветствија",
      tests: "Тестови",
    },
    activate: "Активирај панел",
    deactivate: "Деактивирај панел",
    save: "Зачувај промени",
    reset: "Ресетирај",
    delete: "Избриши панел",
    save_success: "Панелот е успешно зачуван",
    save_error: "Неуспешно зачувување на панелот",
    toggle_activated: "Панелот е успешно активиран",
    toggle_deactivated: "Панелот е успешно деактивиран",
    toggle_error: "Неуспешна промена на статусот на панелот",
    master_card: {
      created_on: "Создаден",
    },
    subtitle_panel: "Панел",
    subtitle_id: "ID на панел",
    subtitle_code_tooltip: "Код на панелот за LIS нарачки",
    subtitle_name_tooltip: "Прикажано назив на панелот",
    subtitle_id_tooltip: "Системски идентификатор",
    delete_dialog: {
      title: "Бришење панел",
      subtitle: "Избриши {name}",
      confirm: "Избриши панел",
      warning: "Овој панел ќе биде трајно отстранет од уредот.",
      has_related_items: "Панелот не може да се избрише додека има LIS соодветствија или тестови.",
    },
  },

  mappings_table: {
    columns: {
      test_name: "Тест",
      mapping_key: "Клуч",
      lis_name: "LIS Назив",
    },
    empty: {
      title: "Нема соодветствија",
      description: "Нема конфигурирани соодветствија за тестовите на овој уред.",
    },
  },

  processors_table: {
    columns: {
      test_name: "Тест",
      rank: "Ред",
      active: "Активен",
      type: "Тип",
    },
    empty: {
      title: "Нема процесори",
      description: "Нема конфигурирани процесори за тестовите на овој уред.",
    },
  },

  coming_soon: {
    panels: {
      title: "Делот е во изградба",
      description: "Овој дел е во изградба и ќе биде достапен наскоро.",
    },
  },

  panels: {
    title: "Панели",
    subtitle: "Тестовни панели конфигурирани за овој уред",
    empty_title: "Нема конфигурирани панели",
    empty_description: "Нема конфигурирани панели за овој уред.",
    columns: {
      panel: "Панел",
      panel_name: "Панел",
      code: "Код",
      name: "Назив",
      behaviour: "Однесување",
      behaviour_column_hint:
        "Начинот на кој панелот се проширува при нарачување — кои тестови се вклучени зависи од оваа поставка.",
      tests: "Тестови",
      tests_count: "Бр. Тестови",
      tests_tooltip: "Број на тестови во панелот.",
      mappings: "LIS соодветствија",
      mappings_count: "Бр. LIS соодветствија",
      mappings_tooltip: "Број на LIS идентификатори конфигурирани за овој панел.",
      created: "Создаден",
      date_time: "Дата / Час",
      date_time_tooltip: "Датумот и времето кога е создаден панелот.",
      actions: "Акции",
      open: "Отвори",
    },
    add_title: "Додавање панел",
    add_subtitle: "Дефинирајте нов тестовен панел за уредот.",
    subtitle_name_tooltip: "Прикажано назив на панелот",
    subtitle_id_tooltip: "Системски идентификатор на панелот",
    edit_title: "Уредување панел",
    action_add: "Додавање панел",
    action_edit: "Уредување панел",
    action_delete: "Бришење панел",
    navigate: "Отвори детали за панелот",
    fields: {
      code: "Код",
      code_hint: "Краток идентификатор на панелот",
      code_placeholder: "пр. LIPID",
      name: "Назив",
      name_hint: "Целосен назив прикажан во извештаите и LIS",
      name_placeholder: "пр. Липиден панел",
      behaviour: "Однесување при порачување",
      status: "Состојба",
      activate: "Активирај",
      deactivate: "Деактивирај",
    },
    validation: {
      code_required: "Кодот е задолжителен",
      code_too_long: "Кодот мора да има најмногу 50 знаци",
      code_duplicate: "Веќе постои панел со овој код за овој уред",
      name_required: "Називот е задолжителен",
      name_too_long: "Називот мора да има најмногу 255 знаци",
      name_duplicate: "Веќе постои панел со овој назив за овој уред",
    },
    delete_title: "Бришење панел",
    delete_message: "Овој панел ќе биде отстранет од конфигурацијата на уредот.",
    delete_blocked: "Прво отстранете ги сите LIS соодветствија и тестови ({mappings} соодветствија, {tests} тестови).",
    status_enabled: "Активен",
    disabled: "Деактивиран",
    status_disabled: "Деактивиран",
    behaviour: {
      none: "Не е порачувачко",
      single_unit: "Единечен елемент",
      fixed: "Фиксирана листа на тестови",
      joined: "Обединета листа на тестови",
    },
    behaviour_hints: {
      none: "Се игнорира при порачување. Користете за нацрт или информативни панели.",
      single_unit: "Го порачува панелот како еден елемент, без проширување кон поединечни тестови.",
      fixed: "Се проширува кон Iris тестовите означени за фиксирано порачување.",
      joined: "Ги комбинира тестовите од адаптерот со Iris тестовите означени за обединето порачување.",
    },
    snackbar_added: "Панелот \u2018{code}\u2019 е додаден",
    snackbar_updated: "Панелот \u2018{code}\u2019 е ажуриран",
    snackbar_deleted: "Панелот \u2018{code}\u2019 е избришан",
    mappings: {
      section_title: "LIS Соодветствија",
      empty_title: "Нема LIS соодветствија",
      empty: "Нема конфигурирани LIS соодветствија за овој панел.",
      columns: {
        mapping_key: "LIS клуч",
        lis_name: "LIS Назив",
        date_time: "Датум / Час",
        actions: "Акции",
      },
      fields: {
        mapping_key: "Клуч за соодветствие",
        mapping_key_hint: "Единствен клуч користен од LIS за идентификација на панелот",
        mapping_key_placeholder: "пр. FBC-01",
        lis_name: "LIS Назив",
        lis_name_hint: "Назив прикажан во извештајот на LIS",
        lis_name_placeholder: "пр. Целосна крвна слика",
      },
      validation: {
        mapping_key_required: "Клучот е задолжителен",
        mapping_key_too_long: "Клучот мора да има најмногу 50 знаци",
        mapping_key_duplicate: "Веќе постои соодветствие со овој клуч за овој панел",
        lis_name_required: "LIS називот е задолжителен",
        lis_name_too_long: "LIS називот мора да има најмногу 255 знаци",
      },
      action_add: "Додавање соодветствие",
      action_edit: "Уредување соодветствие",
      add_subtitle: "Поврзете го овој панел со надворешен LIS идентификатор.",
      subtitle_panel: "Код на панел",
      subtitle_id: "ID на панел",
      subtitle_lis_id: "LIS ID",
      subtitle_created: "Создаден",
      subtitle_panel_tooltip: "Панелот на кој му припаѓа соодветствието",
      subtitle_panel_id_tooltip: "Системски идентификатор на панелот",
      subtitle_lis_id_tooltip: "LIS клуч за соодветствие",
      subtitle_created_tooltip: "Датум на создавање на соодветствието",
      delete_title: "Отстранување LIS соодветствие",
      delete_message: "Ова соодветствие ќе биде отстрането од конфигурацијата на панелот.",
      snackbar_added: "Соодветствието \u2018{key}\u2019 е додадено",
      snackbar_updated: "Соодветствието \u2018{key}\u2019 е ажурирано",
      snackbar_deleted: "Соодветствието \u2018{key}\u2019 е отстрането",
      add_error: "Грешка при додавање на соодветствие. Ве молиме обидете повторно.",
      update_error: "Грешка при ажурирање на соодветствие. Ве молиме обидете повторно.",
      delete_error: "Грешка при отстранување на соодветствие. Ве молиме обидете повторно.",
    },
    tests: {
      section_title: "Тестови",
      empty_title: "Нема тестови во панелот",
      empty: "Нема додадени тестови во овој панел.",
      single_unit_hint:
        "Панелите како единична позиција се порачуваат како еден панел; тестовите се информативни и не ја прошируваат порачката.",
      columns: {
        test: "Тест",
        test_name: "Тест",
        test_code: "Код",
        fixed: "Фиксен",
        joined: "Обединет",
        include_fixed: "Фиксен",
        include_joined: "Обединет",
        date_time: "Датум / Час",
        actions: "Акции",
      },
      test_enabled: "Активен",
      test_disabled: "Деактивиран",
      fields: {
        test: "Тест",
        test_hint: "Изберете тест од овој уред за вклучување во панелот.",
        test_code_label: "Код на тест",
        test_modifier_label: "Модификатор",
        test_id_label: "ID на тест",
        test_locked_hint: "Избраниот тест не може да се промени откако што ёе создадено членството во панелот.",
        include_when_fixed: "Вклучување во панели со фиксирана листа",
        include_when_fixed_hint: 'Тестот ќе биде вклучен во панели со режим "Фиксирана листа на тестови".',
        include_when_joined: "Вклучување во панели со обединета листа",
        include_when_joined_hint: 'Тестот ќе биде вклучен во панели со режим "Обединета листа на тестови".',
        include_fixed: "Вклучување во панели со фиксирана листа",
        include_fixed_hint: 'Тестот ќе биде вклучен во панели со режим "Фиксирана листа на тестови".',
        include_joined: "Вклучување во панели со обединета листа",
        include_joined_hint: 'Тестот ќе биде вклучен во панели со режим "Обединета листа на тестови".',
      },
      validation: {
        test_required: "Изберете тест",
        include_mode_required: "Активирајте барем еден режим на вклучување за овој тест.",
        include_one: "Активирајте барем еден режим на вклучување за овој тест.",
      },
      action_add: "Додавање тест",
      action_edit: "Уредување тест во панел",
      add_subtitle: "Изберете тест од уредот и кога да биде вклучен од панелот.",
      subtitle_panel_tooltip: "Панелот на кој му припаѓа тестот",
      subtitle_test_code_tooltip: "Код на тестот за LIS нарачки",
      subtitle_id_tooltip: "Системски идентификатор на тестот",
      subtitle_test_name_tooltip: "Прикажано назив на тестот",
      subtitle_created_tooltip: "Датум на додавање на тестот во панелот",
      subtitle_created: "Создаден",
      included: "Вклучен",
      not_included: "Не е вклучен",
      included_fixed: "Вклучен во панели со фиксирана листа",
      not_included_fixed: "Не е вклучен во панели со фиксирана листа",
      included_joined: "Вклучен во панели со обединета листа",
      not_included_joined: "Не е вклучен во панели со обединета листа",
      delete_title: "Отстранување тест од панел",
      delete_message: "Овој тест повеќе нема да биде вклучен од панелот.",
      snackbar_added: "Тестот '{test}' е додаден во панелот",
      snackbar_updated: "Тестот '{test}' е ажуриран",
      snackbar_deleted: "Тестот '{test}' е отстранет од панелот",
      add_error: "Грешка при додавање тест во панелот. Ве молиме обидете повторно.",
      update_error: "Грешка при ажурирање тест во панелот. Ве молиме обидете повторно.",
      delete_error: "Грешка при отстранување тест од панелот. Ве молиме обидете повторно.",
    },
  },

  dialogs: {
    sample_types: {
      title: "Видови примероци",
      subtitle: "Видови примероци конфигурирани за овој уред",
      empty_title: "Не е конфигурирано",
      empty_description: "Нема конфигурирани видови примероци за овој уред.",
      status_active: "Активен",
      status_inactive: "Неактивен",
      status_tooltip: "Укажува дали овој вид примерок е активен и достапен за употреба на овој уред.",
      columns: {
        code: "Код на уредот",
        mapping_key: "LIS клуч",
        name: "Назив",
        status: "Статус",
        actions: "Акции",
      },
      add_title: "Додавање вид примерок",
      add_subtitle: "Внесете ги деталите за новиот вид примерок.",
      subtitle_instrument: "Апарат",
      subtitle_instrument_lis_id: "LIS ID на апаратот",
      subtitle_lis_key: "LIS ID на вид примерок",
      subtitle_instrument_tooltip: "Апаратот за кој е конфигуриран видот примерок",
      subtitle_instrument_lis_id_tooltip: "LIS интеграциски клуч на апаратот",
      subtitle_sample_code_tooltip: "Внатрешен код на апаратот за видот примерок",
      subtitle_lis_key_tooltip: "LIS код за видот примерок",
      edit_title: "Уредување вид примерок",
      fields: {
        code: "Код на уредот",
        code_hint: "Кодот што уредот го испраќа во пораките (пр. SER, EDTA, 1)",
        code_placeholder: "пр. SER",
        mapping_key: "LIS клуч",
        mapping_key_hint: "Начинот на кој LIS го идентификува материјалот — може да се разликува од кодот на уредот",
        mapping_key_placeholder: "пр. 5 или SERUM",
        name: "Назив",
        name_hint: "Читлив назив прикажан во интерфејсот и резултатите",
        name_placeholder: "пр. Серум",
        active: "Активен",
        active_hint: "Видот примерок е прифатен и може да се обработи на уредот",
        inactive: "Неактивен",
        inactive_hint: "Видот примерок е деактивиран и нема да биде прифатен од уредот",
      },
      validation: {
        code_required: "Кодот е задолжителен",
        code_too_long: "Кодот мора да биде 50 знаци или помалку",
        mapping_key_required: "Клучот за поврзувување е задолжителен",
        mapping_key_too_long: "Клучот мора да биде 50 знаци или помалку",
        key_taken: "Веќе постои вид примерок со овој код и клуч",
        name_required: "Називот е задолжителен",
        name_too_long: "Називот мора да биде 100 знаци или помалку",
      },
      action_add: "Додавање вид примерок",
      action_edit: "Уредување вид примерок",
      action_delete: "Отстранување вид примерок",
      delete_title: "Отстранување вид примерок",
      delete_message: "Овој вид примерок ќе биде отстранет од конфигурацијата на уредот.",
      snackbar_added: "Типот примерок '{code}' е додаден",
      snackbar_updated: "Типот примерок '{code}' е ажуриран",
      snackbar_deleted: "Типот примерок '{code}' е отстранет",
    },
    rights: {
      title: "Права",
      subtitle: "Права за пристап на корисниците за овој уред",
      empty_title: "Не е конфигурирано",
      empty_description: "Нема конфигурирани права за пристап за овој уред.",
      access_view: "Преглед",
      access_view_validate: "Преглед + Валидација",
      access_view_validate_edit: "Преглед + Валидација + Уредување",
      role_iris_admin: "Ирис Админ",
      role_iris_user: "Ирис Корисник",
      access_tooltip: "Определува кои дејствија можат да ги извршуваат корисниците во оваа улога на уредот.",
      created_time_tooltip: "Датумот и времето кога е создаден овој запис за права.",
      selector_user: "Корисник",
      selector_group: "Група",
      selector_toggle_hint: "Кликнете за преминување помеѓу Корисник и Група",
      columns: {
        user: "Корисник",
        role: "Улога",
        created_time: "Дата / Час",
        access: "Ниво",
        actions: "Акции",
      },
      add_title: "Додавање права",
      add_subtitle: "Доделете ниво на пристап на корисник или група.",
      subtitle_instrument: "Апарат",
      subtitle_instrument_lis_id: "LIS ID на апаратот",
      subtitle_id: "ID",
      subtitle_created: "Создаден",
      subtitle_instrument_tooltip: "Апаратот за кој важи правилото",
      subtitle_instrument_lis_id_tooltip: "LIS интеграциски клуч на апаратот",
      subtitle_id_tooltip: "Системски идентификатор на записот за пристап",
      subtitle_created_tooltip: "Датум на создавање на записот за пристап",
      edit_title: "Уредување права",
      fields: {
        user: "Корисник",
        user_hint: "Корисничко ime (од OIDC preferred_username)",
        user_placeholder: "пр. ivan.ivanov",
        group: "Група",
        group_hint: "Ime на групата (од OIDC location)",
        group_placeholder: "пр. lab-technicians",
        role: "Улога",
        access: "Ниво на пристап",
        access_hint: "Определува кои дејствија можат да ги извршуваат корисниците со оваа улога на уредот",
      },
      validation: {
        user_required: "Корисничкото име е задолжително",
        user_too_long: "Корисничкото име мора да биде 100 знаци или помалку",
        user_taken: "Веќе постои запис за овој корисник",
        group_required: "Името на групата е задолжително",
        group_too_long: "Името на групата мора да биде 100 знаци или помалку",
        group_taken: "Веќе постои запис за оваа група",
      },
      action_add: "Додавање права",
      action_edit: "Уредување права",
      action_delete: "Отстранување права",
      delete_title: "Отстранување права",
      delete_message_user: "Овој корисник ќе го изгуби пристапот до уредот.",
      delete_message_group: "Оваа група ќе го изгуби пристапот до уредот.",
      snackbar_added: "Правото за '{user}' е додадено",
      snackbar_updated: "Правото за '{user}' е ажурирано",
      snackbar_deleted: "Правото за '{user}' е отстрането",
    },
    flags: {
      title: "Знамиња",
      subtitle: "Знамиња на резултати конфигурирани за овој уред",
      empty_title: "Не е конфигурирано",
      empty_description: "Нема конфигурирани знамиња за овој уред.",
      status_filter: "Филтрира при објавување",
      status_no_filter: "Објавува нормално",
      columns: {
        code: "Код",
        description: "Опис",
        severity: "Тежина",
        severity_tooltip:
          "Го означува нивото на влијание на знамето — од информативни белешки до критични состојби кои бараат итна акција",
        created_time: "Дата / Час",
        created_time_tooltip: "Датумот и времето кога е создадено знамето.",
        actions: "Акции",
      },
      add_title: "Додавање знаме",
      add_subtitle: "Дефинирајте ново знаме за резултати на уредот.",
      subtitle_instrument: "Апарат",
      subtitle_instrument_lis_id: "LIS ID на апаратот",
      subtitle_flag: "Код на знаме",
      subtitle_flag_description: "Опис",
      subtitle_created: "Создаден",
      subtitle_instrument_tooltip: "Апаратот на кој му припаѓа флагот",
      subtitle_instrument_lis_id_tooltip: "LIS интеграциски клуч на апаратот",
      subtitle_flag_code_tooltip: "Код на флагот испратен од апаратот",
      subtitle_created_tooltip: "Датум на конфигурирање на флагот",
      edit_title: "Уредување знаме",
      fields: {
        code: "Код",
        code_hint: "Празните места се заменуваат со долна црта",
        code_placeholder: "пр. MAINTENANCE_MODE",
        description: "Опис",
        description_hint: "Краток опис прикажан во интерфејсот",
        description_placeholder: "пр. Режим на одржување",
        flag_type: "Филтрирање",
        is_filter: "Филтрирај резултати",
        is_filter_hint: "Резултатите со ово знаме џе бидат исклучени од објавувањето",
        not_filter: "Објави нормално",
        not_filter_hint: "Резултатите се објавуваат нормално — знамето не ги супресира",
        severity: "Тежина",
        severity_information: "Информација",
        severity_information_hint: "Информативна белешка \u2014 не е потребна акција",
        severity_warning: "Предупредување",
        severity_warning_hint: "Потенцијален проблем \u2014 се препорачува проверка",
        severity_danger: "Опасност",
        severity_danger_hint: "Сериозен проблем \u2014 потребна е акција",
        severity_panic: "Паника",
        severity_panic_hint: "Критична состојба \u2014 потребна е итна акција",
      },
      validation: {
        code_required: "Кодот е задолжителен",
        code_too_long: "Кодот мора да биде 100 знаци или помалку",
        code_taken: "Веќе постои знаме со овој код",
        description_required: "Описот е задолжителен",
        description_too_long: "Описот мора да биде 500 знаци или помалку",
      },
      action_add: "Додавање знаме",
      action_edit: "Уредување знаме",
      action_delete: "Бришење знаме",
      delete_title: "Бришење знаме",
      delete_message: "Ова знаме ќе биде отстрането од конфигурацијата на уредот.",
      snackbar_added: "Знамето '{code}' е додадено",
      snackbar_updated: "Знамето '{code}' е ажурирано",
      snackbar_deleted: "Знамето '{code}' е отстрането",
    },
  },
};
